    
<div class="container">
    <div class="row mb-3">
        <div class="col section-title-full">
            <h1>
                <span i18n>Editar vehículo</span>
            </h1>
        </div>
    </div>
</div>

<div class="container">
    <div class="row my-5" *ngIf="vehicle">
        <div class="col">

            <h2 class="my-4" i18n>Vehículo</h2>

            <div class="card">
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label for="vehicle" class="form-label"><span i18n>Matrícula</span>: </label>
                        <input type="text" class="form-control" id="vehicle" [(ngModel)]="vehicle.vehiclePlate">
                    </div>
                    <div class="col-md-4 mb-3">
                        <label for="pais-matriculacion" class="form-label">
                            <span i18n>País de matriculación</span>:
                        </label>
                        <select id="pais-matriculacion" class="form-select" [(ngModel)]="vehicle.vehicleCountryCode">
                            <option value="0" i18n>Selecciona un país</option>
                            @for (country of countries; track country.code) {
                            <option value="{{country.code}}">{{country.name}}</option>
                            }
                        </select>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label for="chassis" class="form-label"><span i18n>Alias</span>: </label>
                        <input type="text" class="form-control" id="chassis" [(ngModel)]="vehicle.vehicleAlias">
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-5">
        <div class="col text-center btn-actions">
            <button type="button" class="btn btn-primary btn-rounded" (click)="save()" i18n>Actualizar</button>
            <button type="button" class="btn btn-outline-primary btn-rounded" (click)="goBack()" i18n>Volver</button>
        </div>
    </div>
</div>